import { queryOptions } from '@tanstack/react-query'
import { apiGet, apiPost } from './client'

/**
 * Settings → Easeedesk → Email servers.
 *
 * Perechile vechi: `settings/easeedesk/email_server_settings`,
 * `notifications_servers`, `create_notifications_server`,
 * `save_server_settings`, `remove_notification_server`,
 * `save_notifications_scheme`, `conversation_settings`.
 *
 * PAROLA NU VINE NICIODATA INCOACE: serverul spune doar daca EXISTA una
 * (`has_password`). Casuta lasata goala, sau cu cele opt stelute pe care le
 * punea si macheta veche, inseamna „lasa parola cum e".
 *
 * `apiGet` / `apiPost` pun ELE `/api/v2` in fata caii.
 */

/** Cele opt stelute din machete: „nu m-am atins de parola". */
export const PASSWORD_UNCHANGED = '********'

export interface EmailServerRow {
  ID: number
  scheme_name: string
  email_address: string
  from_name: string
  enable_smtp: number
  smtp_host: string
  smtp_user: string
  smtp_port: string
  smtp_timeout: string
  ticket_in_subject: number
  has_password: boolean
}

export interface EmailServersList {
  servers: EmailServerRow[]
}

export interface ConversationSettings {
  email_address: string
  from_name: string
  add_from_name: number
  enable_smtp: number
  smtp_host: string
  smtp_user: string
  smtp_port: string
  smtp_timeout: string
  has_password: boolean
}

export interface EmailServersShell {
  title: string
  moduleUrl: string
  server_list: { ID: number; scheme_name: string }[]
  ticket_type_servers: { type_id: number; type_name: string; server_id: number }[]
  conversation: ConversationSettings | null
}

export function emailServersShellQuery() {
  return queryOptions({
    queryKey: ['settings', 'easeedesk', 'email_servers'],
    queryFn: () => apiGet<EmailServersShell>('/settings/easeedesk/email_servers'),
  })
}

export function emailServersListQuery() {
  return queryOptions({
    queryKey: ['settings', 'easeedesk', 'email_servers', 'list'],
    queryFn: () => apiGet<EmailServersList>('/settings/easeedesk/email_servers/list'),
  })
}

export function createEmailServer() {
  return apiPost<{ ok?: boolean; ID?: number }>('/settings/easeedesk/email_servers', {})
}

export function saveEmailServer(server: number, fields: Record<string, string>) {
  return apiPost<{ ok?: boolean }>(`/settings/easeedesk/email_servers/${server}`, fields)
}

export function removeEmailServer(server: number) {
  return apiPost<{ ok?: boolean }>(`/settings/easeedesk/email_servers/${server}/remove`, {})
}

export function saveServerDispatching(ticket_type: number, server_id: number) {
  return apiPost<{ ok?: boolean }>('/settings/easeedesk/email_servers/dispatching', { ticket_type, server_id })
}

export function saveConversationSettings(fields: Record<string, string>) {
  return apiPost<{ ok?: boolean }>('/settings/easeedesk/email_servers/conversation', fields)
}
